(function ( $ ) {
    $.fn.companySelector = function(val, params) {
        $(this).each(function() {
            var elm = $(this);

            elm.attr('data-search-type', 'company');


            var onChange = function(obj) {
                if(typeof obj == 'string') {
                    obj = JSON.parse(obj);
                }
                elm.removeClass('has-special-selector').companySelector(obj.id, params);
            };

            elm.specialSelector({
                url: '/ajax/getCompanies',
                val: val,
                option: function(row) {
                    if  (row.notes) {
                        delete row.notes;
                    }
                    return '<option value="'+row.id+'" data-object="' + btoa(encodeURIComponent(JSON.stringify(row))) + '">'+row.name+(row.address != undefined ? ' / '+row.address.city : '')+'</option>';
                },
                addNew: function() {
                    add_company(function(company) {
                        onChange(company);
                    }.bind([elm]));
                }.bind([elm]),
                onOpen: function(id) {
                view_company(id, {callback: function(obj, elm, popup) {
                    onChange(obj);
                    popup.close();
                }});
            }
            });
        });
        return this;
    };

}( jQuery ));